import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getRightTypeOptions, NAME, RIGHT_TYPE } from '../../../../fields'

import Tabs from '../../../../../../../../features/components/Tabs'
import Field from '../../../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'

import { useIsGamAccountConnectedToRightsHolderAccount } from '../../sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/hooks'

import { selectedPartnershipIsDigitalSelector } from '../../../../../../../../modules/selectors/partnerships'
import { selectedPartnershipRightsHolderSelfAccountSelector } from '../../../../../../../../modules/selectors/app'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

function NameAndTypeSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const selectedPartnershipIsDigital = useSelector(selectedPartnershipIsDigitalSelector)
  const selectedPartnershipRightsHolderSelfAccount = useSelector(selectedPartnershipRightsHolderSelfAccountSelector)

  const rightsHolderAdServer = selectedPartnershipRightsHolderSelfAccount?.ad_server
  const isGamAccountConnected = useIsGamAccountConnectedToRightsHolderAccount()

  const { values } = formik

  const rightTypeOptions = useMemo(
    () =>
      getRightTypeOptions({
        isDigitalRightTypeAllowed: selectedPartnershipIsDigital,
        isOnsiteRightTypeAllowed: !!rightsHolderAdServer || isGamAccountConnected
      }),
    [selectedPartnershipIsDigital, rightsHolderAdServer, isGamAccountConnected]
  )

  return (
    <section className={drawerFormClasses.section}>
      <div className={drawerFormClasses.tabsContainer}>
        <h3 className={drawerFormClasses.sectionTitle}>{t('Right type and name')}</h3>
        {rightTypeOptions.length < 4 && (
          <Tabs
            options={rightTypeOptions}
            onSelectValue={value => formik.setFieldValue(RIGHT_TYPE, value)}
            selectedValue={values[RIGHT_TYPE]}
          />
        )}
      </div>
      {rightTypeOptions.length > 3 && (
        <Field formik={formik} name={RIGHT_TYPE} options={rightTypeOptions} placeholder={'Right type'} />
      )}
      <FieldLabelWrapper label="Right name">
        <Field
          placeholder="Name of right"
          formik={formik}
          name={NAME}
          enableReinitialize
          autoComplete="off"
          disablePlaceholderFormatting
        />
      </FieldLabelWrapper>
    </section>
  )
}

export default NameAndTypeSection
